import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
};
const _hoisted_2 = {
  class: "flex items-center justify-between"
};
const _hoisted_3 = {
  class: "text-base font-semibold text-slate-900"
};
const _hoisted_4 = {
  key: 0,
  class: "mt-2 text-xs text-slate-500"
};
const _hoisted_5 = {
  key: 1,
  class: "mt-4 space-y-3"
};
const _hoisted_6 = {
  key: 2,
  class: "mt-4 space-y-3"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "flex items-center gap-3"
};
const _hoisted_9 = {
  class: "flex h-10 w-10 items-center justify-center rounded-lg bg-white overflow-hidden"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  key: 1,
  class: "h-5 w-5 text-primary-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_12 = ["d"];
const _hoisted_13 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_14 = {
  class: "mt-1 flex items-center gap-2 text-xs text-slate-500"
};
const _hoisted_15 = {
  key: 0,
  class: "flex items-center gap-2"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  key: 0,
  class: "rounded-xl border border-dashed border-slate-200 p-6 text-center text-sm text-slate-500"
};
const defaultIcon = 'M12 4v16m8-8H4';
export default {
  __name: 'ProductCategorySidebar',
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedCategoryId: {
      type: [String, Number],
      default: ''
    },
    title: {
      type: String,
      default: '产品类型管理'
    },
    description: {
      type: String,
      default: '删除前会校验，类型下存在产品将无法删除。'
    },
    showAddButton: {
      type: Boolean,
      default: true
    },
    showActions: {
      type: Boolean,
      default: true
    }
  },
  emits: ['add', 'edit', 'delete', 'select'],
  setup(__props) {
    const isSvgPath = icon => {
      if (!icon) return false;
      return /^[MLHVCSQTAZmlhvcsqtaz\d\s.,-]+$/.test(icon.trim());
    };
    const resolveFileUrl = fileKey => {
      if (!fileKey) return '';
      if (/^https?:\/\//i.test(fileKey)) return fileKey;
      return `${process.env.VUE_APP_API_BASE_URL || ''}/${fileKey}`.replace(/\/+/g, '/').replace(':/', '://');
    };
    return (_ctx, _cache) => {
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1), __props.showAddButton ? _withDirectives((_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('add')),
        class: "rounded-lg border border-slate-200 px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-50"
      }, [...(_cache[1] || (_cache[1] = [_createTextVNode(" 新增类型 ", -1)]))])), [[_directive_permission, 'product:category:add']]) : _createCommentVNode("", true)]), __props.description ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.description), 1)) : _createCommentVNode("", true), __props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, n => {
        return _createElementVNode("div", {
          key: n,
          class: "h-16 rounded-xl border border-slate-200 bg-slate-50"
        });
      }), 64))])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, category => {
        return _openBlock(), _createElementBlock("div", {
          key: category.id,
          onClick: $event => _ctx.$emit('select', category.id),
          class: _normalizeClass(['flex cursor-pointer items-center justify-between rounded-xl border p-4 transition', __props.selectedCategoryId && Number(__props.selectedCategoryId) === category.id ? 'border-primary-300 bg-primary-50/70 ring-1 ring-primary-200' : 'border-slate-200 bg-slate-50/70 hover:bg-slate-50'])
        }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [category.icon && !isSvgPath(category.icon) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: resolveFileUrl(category.icon),
          class: "h-full w-full object-cover",
          alt: ""
        }, null, 8, _hoisted_10)) : (_openBlock(), _createElementBlock("svg", _hoisted_11, [_createElementVNode("path", {
          d: category.icon && isSvgPath(category.icon) ? category.icon : defaultIcon,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_12)]))]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_13, _toDisplayString(category.name), 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", null, _toDisplayString(category.status === 1 ? '启用' : '停用'), 1)])])]), __props.showActions ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _withModifiers($event => _ctx.$emit('edit', category), ["stop"]),
          class: "p-1.5 text-slate-400 hover:text-primary-600 transition-colors",
          title: "编辑"
        }, [...(_cache[2] || (_cache[2] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        })], -1)]))], 8, _hoisted_16)), [[_directive_permission, 'product:category:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _withModifiers($event => _ctx.$emit('delete', category), ["stop"]),
          class: "p-1.5 text-slate-400 hover:text-red-600 transition-colors",
          title: "删除"
        }, [...(_cache[3] || (_cache[3] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
        })], -1)]))], 8, _hoisted_17)), [[_directive_permission, 'product:category:delete']])])) : _createCommentVNode("", true)], 10, _hoisted_7);
      }), 128)), !__props.categories.length ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 暂无类型数据 ")) : _createCommentVNode("", true)]))]);
    };
  }
};